export default {
  title: 'Attorney Detail Report',
  backButton: 'Back to attorney report',
};
